import Crud from '../components/User/Crud'
import View from '../components/User/View'
import Form from '../components/User/Form'

let routes = {
    path: '/users',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/users/add',
            name: 'Novo Usuário',
            component: Form
        },
        {
            path: '/users/edit/:id?',
            name: 'Editar Usuário',
            component: Form
        },
        {
            path: '/users/view/:id?',
            name: 'Visualizar Usuário',
            component: View
        },
        {
            path: '/users',
            name: 'Usuários',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/user.js